
import { Component, Prop, Vue } from 'vue-property-decorator';
import Dialog from '@/components/Dialog.vue';
import api from '@/api';
import { Route } from 'vue-router';
import Swal from 'sweetalert2';

const { member, payment } = api;

@Component({ components: { Dialog } })
export default class UserPointDetail extends Vue {
  @Prop() private userId!: string;

  @Prop() private tid!: number;

  private IsRefundClicked: boolean = false;

  private get IsRefundBtnDisabled() {
    return this.IsRefundClicked
      || !(this.data.payAmount && this.data.displayType !== 32 && this.data.paymentStatus === 0);
  }

  private data = {
    createdOn: null,
    tranType: 0,
    point: null,
    transactionId: null,
    payMethod: 0,
    payMethodName: null,
    payAmount: null,
    serviceFee: null,
    quantity: null,
    shippingFee: 0,
    shippingStatus: null,
    productType: 0,
    displayType: null,
    shippingInformation: null,
    pointBack: null,
    productName: null,
    subProductName: null,
    amount: null,
    discount: null,
    invitedUser: null,
    otherPointName: null,
    otherPointAmount: 0,
    paymentStatus: null,
  };

  private productTypes = ['', '商品', '點數', '', '折價券'];

  private get productType() {
    return this.productTypes[this.data.productType];
  }

  private tranTypes = [
    { value: null, text: '所有' },
    { value: 1, text: '好友轉讓' },
    { value: 2, text: 'SP序號加點兌換' },
    { value: 3, text: '使用點數兌換外部品項' },
    { value: 4, text: '系統給點' },
    { value: 5, text: '活動贈點' },
    { value: 6, text: '邀請好友贈點' },
    { value: 7, text: '支付點數扣點' },
    { value: 8, text: '交易手續費' },
    { value: 9, text: '交易虛擬貨幣' },
    { value: 10, text: '退款' },
    { value: 11, text: '點數回饋' },
    { value: 12, text: '推薦贈禮' },
    { value: 13, text: '問卷贈點' },
    { value: 14, text: '活動贈點' },
    { value: 15, text: '任務獎勵' },
  ];

  private paymentStatusTypes = [
    { value: 0, text: '交易完成' },
    { value: 1, text: '交易失敗' },
    { value: 2, text: '交易處理中' },
    { value: 3, text: '等待付款' },
    { value: 4, text: '付款交易不存在' },
    { value: 5, text: '已退款' },
    { value: 6, text: '取消' },
    { value: 7, text: '交易逾期' },
    { value: 8, text: '產品售完' },
  ];

  private get tranType() {
    return this.tranTypes[this.data.tranType]?.text;
  }

  private get paymentStatusType() {
    return this.data.paymentStatus !== null && this.paymentStatusTypes[this.data.paymentStatus!]?.text;
  }

  private async RefundPayment(paymentId: string) {
    await Swal.fire(
      {
        title: '請再次確認是否要退款?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      },
    ).then(async (result) => {
      if (result.isConfirmed) {
        this.IsRefundClicked = true;
        const { status, message } = await payment.refund(paymentId);
        if (status === 1) {
          await Swal.fire({ icon: 'success', title: '訂單退款已在執行中，請稍後幾分鐘再回來確認訂單狀態。' });
        } else {
          await Swal.fire({ icon: 'warning', title: message });
          this.IsRefundClicked = false;
        }
      }
    });
  }

  private async back() {
    await this.$router.back();
  }

  private async requestData() {
    const { data } = await member.getPoint(this.userId, this.tid);
    this.data = data;
  }

  private get shippingFeeType() {
    const { shippingFee, payAmount, otherPointAmount } = this.data;
    if (!shippingFee) return '';
    if (payAmount && otherPointAmount < shippingFee) return 'cash';
    if (otherPointAmount >= shippingFee) return 'otherPoint';
    return 'point';
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: UserPointDetail) => void) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }
}
